"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResponsiveText = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2020 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var debounce_1 = tslib_1.__importDefault(require("lodash/debounce"));
var isNumber_1 = tslib_1.__importDefault(require("lodash/isNumber"));
/**
 * @internal
 */
exports.ResponsiveText = function (_a) {
    var _b = _a.tagName, Tag = _b === void 0 ? "div" : _b, tagClassName = _a.tagClassName, title = _a.title, children = _a.children, _c = _a.windowResizeRefreshDelay, windowResizeRefreshDelay = _c === void 0 ? 50 : _c, _d = _a.window, windowInstance = _d === void 0 ? window : _d;
    var _e = tslib_1.__read(react_1.useState(null), 2), fontSize = _e[0], setFontSize = _e[1];
    var containerRef = react_1.useRef();
    var adjustFontSize = function () {
        if (!containerRef.current) {
            return;
        }
        var currentStyle = windowInstance.getComputedStyle(containerRef.current, null);
        var currentFontSize = parseFloat(currentStyle.fontSize);
        if (isNumber_1.default(currentFontSize)) {
            var scrollWidth = containerRef.current.scrollWidth;
            var width = containerRef.current.getBoundingClientRect().width;
            var ratio = Math.round(width) / scrollWidth;
            var size = Math.floor(currentFontSize * ratio);
            setFontSize(size);
        }
    };
    react_1.useLayoutEffect(function () {
        var handleWindowResize = debounce_1.default(function () {
            // reset font size so that we can read the default fontSize in adjustFontSize later
            setFontSize(null);
        }, windowResizeRefreshDelay);
        windowInstance.addEventListener("resize", handleWindowResize);
        return function () { return windowInstance.removeEventListener("resize", handleWindowResize); };
    }, [windowResizeRefreshDelay]);
    react_1.useLayoutEffect(function () {
        // reset font size so that we can read the default fontSize in adjustFontSize later
        setFontSize(null);
    }, [children, tagClassName]);
    react_1.useLayoutEffect(function () {
        if (!fontSize) {
            // then adjust the font again
            adjustFontSize();
        }
    }, [fontSize]);
    return (react_1.default.createElement(Tag, { className: tagClassName, ref: containerRef, style: fontSize ? { fontSize: fontSize + "px" } : undefined, title: title }, children));
};
//# sourceMappingURL=ResponsiveText.js.map